import { render, staticRenderFns } from "./NotAcceptedList.vue?vue&type=template&id=067388e9&"
import script from "./NotAcceptedList.vue?vue&type=script&lang=js&"
export * from "./NotAcceptedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports